export const PRINTED_ORDER_IDS_LIMIT = 200;

export const addToPrintQueue = (print, printedOrderIds, order) => {
  const isQueued = print.some(({ id }) => id === order.id);
  if (isQueued || printedOrderIds.includes(order.id)) {
    return null;
  }
  return { print: [...print, order] };
};

export const markOrderAsPrinted = (print, printedOrderIds, orderId) => {
  const remaining = print.filter(({ id }) => id !== orderId);
  if (remaining.length === print.length) {
    return null;
  }
  return {
    print: remaining,
    printedOrderIds: [...printedOrderIds, orderId].slice(-PRINTED_ORDER_IDS_LIMIT)
  };
};
